import React from "react";
import { Field, EditView, useGet } from "@builtbypixel/nucleus";
import { Box } from "@builtbypixel/plasma";
import useSWR from "swr";
import setup from "./setup";
import { useParams } from "react-router-dom";
import * as yup from "yup";

const EditForm = () => {
  const { type } = useParams();

  const { data: roles } = useSWR("/roles", useGet);

  const useValidation = () => {
    if (type === "create") {
      return yup.object().shape({
        first_name: yup.string().required(),
        last_name: yup.string().required(),
        email: yup.string().email().required(),
        password: yup.string().min(8).required(),
        password_confirmation: yup
          .string()
          .required()
          .oneOf([yup.ref("password")], "Passwords don't match"),
        role_id: yup.number().required(),
      });
    }
    if (type === "edit") {
      return yup.object().shape({
        first_name: yup.string().required(),
        last_name: yup.string().required(),
        email: yup.string().email().required(),
        password: yup.string(),
        password_confirmation: yup.string().when("password", {
          is: (password) => password && password.length > 0,
          then: yup
            .string()
            .required("Field is required")
            .oneOf([yup.ref("password")], "Passwords don't match"),
        }),
        role_id: yup.number().required(),
      });
    }
  };

  return (
    <EditView setup={setup} validationSchema={useValidation()}>
      <Box maxWidth="600px" w="100%" margin=" 25px auto">
        <Field
          auto
          isFullWidth
          name="first_name"
          component="text"
          label="First Name"
          isRequired
          rules={{ required: true }}
        />
        <Field
          auto
          isFullWidth
          name="last_name"
          component="text"
          label="Last Name"
          isRequired
          rules={{ required: true }}
        />
        <Field
          auto
          isFullWidth
          name="email"
          component="text"
          type="email"
          label="Email Address"
          isRequired
          rules={{ required: true }}
        />
        <Field
          auto
          isFullWidth
          name="role_id"
          component="select"
          options={roles?.data}
          label="Role"
          labelKey="name"
          valueLKey="id"
          isRequired
          rules={{ required: true }}
        />

        <Box mt="25px">
          <Field
            auto
            isFullWidth
            name="password"
            component="text"
            type="password"
            label={type === "create" ? "Password" : "Change Password"}
            isRequired={type === "create"}
            rules={{ required: type === "create" }}
          />
          <Field
            auto
            isFullWidth
            name="password_confirmation"
            component="text"
            type="password"
            label={
              type === "create" ? "Confirm Password" : "Confirm New Password"
            }
            isRequired={type === "create"}
            rules={{ required: type === "create" }}
          />
        </Box>
      </Box>
    </EditView>
  );
};

export default EditForm;
